import React from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import _ActionText from "ConfirmationBanner-ActionText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/ConfirmationBanner.tsx?styleId=ActionText";
import _Banner from "ConfirmationBanner-Banner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/ConfirmationBanner.tsx?styleId=Banner";
import _Message from "ConfirmationBanner-Message.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/ConfirmationBanner.tsx?styleId=Message";


type Action = {
  href: string;
  name: string;
};

type Props = {
  email: string;
  user: User;
};

type User = {
  banned?: boolean;
  // Whether there is an existing request to unflag this user
  requested_unflag?: boolean;
};

const ActionText = /*#__PURE__*/styled("a", null, {
  displayName: "ActionText",
  styles: _ActionText
});

const Banner = /*#__PURE__*/styled("div", null, {
  displayName: "Banner",
  styles: _Banner
});

const Message = /*#__PURE__*/styled("p", null, {
  displayName: "Message",
  styles: _Message
});

const getMessageAndActions = (
  email: string,
  user: User,
): [string, Action[]] => {
  let actions: Action[] = [];
  let message: string;

  if (user.banned) {
    actions = [
      {
        href: '/user_unflag_requests/new',
        name: 'Request Unflagging',
      },
    ];
    message =
      'Your account was flagged as suspicious by an automated system. If this was an error, please accept our apologies.';
    if (user.requested_unflag) {
      message =
        "Your account was flagged as suspicious, and your reconsideration request is awaiting manual review. We're sorry for any inconvenience.";
    }
  } else {
    actions = [
      {
        // TODO: Use routes here
        href: '/confirm/send_new_email',
        name: 'Resend',
      },
      {
        // TODO: Use routes here
        href: '/confirm/sent#email',
        name: 'Change Email',
      },
    ];
    message = `Please confirm your account. We've sent a confirmation link to ${email}`;
  }

  return [message, actions];
};

const ConfirmationBanner: React.FC<Props> = ({ email, user }) => {
  if (!user) return null;

  const [message, actions] = getMessageAndActions(email, user);

  return (
    <Banner>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <Message>{message}</Message>
      {actions.map((action) => (
        <ActionText href={action.href} key={action.name}>
          {action.name}
        </ActionText>
      ))}
    </Banner>
  );
};

export default ConfirmationBanner;
